import React from 'react';
import { slideWrapper } from '../components/slide';
import { SantaPresenterSolution } from '../components/santa-presenter-solution';
import { RoundLetters, RoundType } from '@disco/data';

export const ArtHousePuzzle8Solution = slideWrapper(
  ({ countingResults, countingResultsLoading, step, getImg }) => {
    const { answers } = step;

    return (
      <>
        <SantaPresenterSolution
          {...{ countingResults, countingResultsLoading, getImg, answers, letters: RoundLetters[3] }}
        />
      </>
    );
  },
  { countSantaAnswersTour: RoundType.ArtHouse }
);
